import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { DealsPage } from "@/components/deals/deals-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/deals",
  loader: async () => {
    const [dealsRes, pipelinesRes] = await Promise.all([
      fetch("/api/deals?pageSize=50"),
      fetch("/api/hubspot/pipelines/deals"),
    ]);
    const dealsData = dealsRes.ok ? await dealsRes.json() : { deals: [], total: 0 };
    const plData = pipelinesRes.ok ? await pipelinesRes.json() : { results: [] };
    return {
      deals: dealsData.deals ?? [],
      total: dealsData.total ?? 0,
      pipelines: plData.results ?? [],
    };
  },
  component: DealsPageGuard,
});

function DealsPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <DealsPage />;
}
